import styled from "styled-components/macro";
import { IconButton, IconButtonProps } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const SIconButton = styled(IconButton)`
  position: absolute;
  top: 0;
  right: -2px;
  color: #aaa;
`;

type Props = IconButtonProps;

export function QuestCloseButton(props: Props) {
  return (
    <SIconButton {...props}>
      <CloseIcon />
    </SIconButton>
  );
}
